module.exports = __webpack_public_path__ + "img/img13.ffc14c17.jpg";